import axios from "axios";
import API_BASE_URL from "../config/apiConfig";

const config = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("adminToken") || ""}` },
});

const url = (bookingId) => `${API_BASE_URL}/api/admin/bookings/${bookingId}/hotel-payments`;

export const getBookingHotelPayments = async (bookingId) =>
  (await axios.get(url(bookingId), config())).data;

export const saveBookingHotelPayable = async (bookingId, hotelId, totalPayable) =>
  (await axios.put(`${url(bookingId)}/${hotelId}/payable`, { totalPayable }, config())).data;

// Drops a hand-entered amount and tracks the quoted hotel cost again.
export const followQuoteBookingHotelPayable = async (bookingId, hotelId) =>
  (await axios.put(`${url(bookingId)}/${hotelId}/payable`, { followQuote: true }, config())).data;

export const recordBookingHotelPayment = async (bookingId, hotelId, payment) =>
  (await axios.post(`${url(bookingId)}/${hotelId}`, payment, config())).data;

// Corrections need a reason; a delete keeps the payment on record but out of every total.
export const editBookingHotelPayment = async (bookingId, hotelId, paymentId, change) =>
  (await axios.put(`${url(bookingId)}/${hotelId}/payments/${paymentId}`, change, config())).data;

export const deleteBookingHotelPayment = async (bookingId, hotelId, paymentId, reason) =>
  (await axios.post(`${url(bookingId)}/${hotelId}/payments/${paymentId}/delete`, { reason }, config())).data;
